import { NgModule } from '@angular/core';
import { MapperLibraryComponent } from './mapper-library.component';



@NgModule({
  declarations: [
    MapperLibraryComponent
  ],
  imports: [
  ],
  exports: [
    MapperLibraryComponent
  ]
})
export class MapperLibraryModule { }
